import cliente from './AxiosCliente'; 

import u from './../utils/utils';

const url = 'controller/tipousuario.php'; 

export default class {
 
    ingresar = (nombre, descripcion, mod_blog, mod_cursos, mod_anuncios, mod_calificaciones, mod_material, mod_postulaciones, mod_usuarios, mod_tipousuarios, mod_estudiantes, mod_ver_anuncios, mod_ver_calificaciones, mod_ver_material, mod_galeria) => {
        let formData = new FormData();
        formData.append('funcion', 'ingresar');
        formData.append('nombre', nombre);
        formData.append('descripcion', descripcion);
        formData.append('mod_blog', u.booleanToNum(mod_blog));
        formData.append('mod_cursos', u.booleanToNum(mod_cursos));
        formData.append('mod_anuncios', u.booleanToNum(mod_anuncios));
        formData.append('mod_calificaciones', u.booleanToNum(mod_calificaciones));
        formData.append('mod_material', u.booleanToNum(mod_material));
        formData.append('mod_postulaciones', u.booleanToNum(mod_postulaciones));
        formData.append('mod_usuarios', u.booleanToNum(mod_usuarios));
        formData.append('mod_tipousuarios', u.booleanToNum(mod_tipousuarios));
        formData.append('mod_estudiantes', u.booleanToNum(mod_estudiantes));
        formData.append('mod_ver_anuncios', u.booleanToNum(mod_ver_anuncios));
        formData.append('mod_ver_calificaciones', u.booleanToNum(mod_ver_calificaciones));
        formData.append('mod_ver_material', u.booleanToNum(mod_ver_material));
        formData.append('mod_galeria', u.booleanToNum(mod_galeria));


        let consulta =  cliente.post({url: url, data: formData})
        return consulta;
    }

    editar = (id, nombre, descripcion, mod_blog, mod_cursos, mod_anuncios, mod_calificaciones, mod_material, mod_postulaciones, mod_usuarios, mod_tipousuarios, mod_estudiantes, mod_ver_anuncios, mod_ver_calificaciones, mod_ver_material, mod_galeria) => {
        let formData = new FormData();
        formData.append('funcion', 'editar');
        formData.append('id', id);
        formData.append('nombre', nombre);
        formData.append('descripcion', descripcion);
        formData.append('mod_blog', u.booleanToNum(mod_blog));
        formData.append('mod_cursos', u.booleanToNum(mod_cursos));
        formData.append('mod_anuncios', u.booleanToNum(mod_anuncios));
        formData.append('mod_calificaciones', u.booleanToNum(mod_calificaciones));
        formData.append('mod_material', u.booleanToNum(mod_material));
        formData.append('mod_postulaciones', u.booleanToNum(mod_postulaciones));
        formData.append('mod_usuarios', u.booleanToNum(mod_usuarios));
        formData.append('mod_tipousuarios', u.booleanToNum(mod_tipousuarios));
        formData.append('mod_estudiantes', u.booleanToNum(mod_estudiantes));
        formData.append('mod_ver_anuncios', u.booleanToNum(mod_ver_anuncios));
        formData.append('mod_ver_calificaciones', u.booleanToNum(mod_ver_calificaciones));
        formData.append('mod_ver_material', u.booleanToNum(mod_ver_material));
        formData.append('mod_galeria', u.booleanToNum(mod_galeria));

        let consulta =  cliente.post({url: url, data: formData})
        return consulta;
    }

    mostrar = () => {
        let formData = new FormData();
        formData.append('funcion', 'mostrar')
        
        let consulta =  cliente.post({url: url, data: formData})
        return consulta;
    }

    resumen = () => {
        let formData = new FormData();
        formData.append('funcion', 'resumen')
        
        let consulta =  cliente.post({url: url, data: formData})
        return consulta;
    }

    eliminar = (id) => {
        let formData = new FormData();
        formData.append('funcion', 'eliminar');
        formData.append('id', id);

        let consulta =  cliente.post({url: url, data: formData})
        return consulta;
    }

    tipoUsuario = (id) => {
        let formData = new FormData();
        formData.append('funcion', 'tipousuario');
        formData.append('id', id);

        let consulta =  cliente.post({url: url, data: formData})
        return consulta;
    }







}